import {of,  Observable } from 'rxjs';
import { filter, take, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Locale } from '../interfaces/locale.interface';
import { FacebookService } from '../../../../shared/services/facebook.service';

@Injectable()
export class LocalesApiService {

  _defaultLang = 'en_US';
  lang: string         = this._defaultLang;

  _locales: Array<Locale>;
  locales$ = this.fbService
                 .get({
                   path: '/search',
                   params: JSON.stringify({
                     type:   'adlocale',
                     limit:  500,
                     locale: this.lang
                   })
                 }).pipe(
                    map(response => response.data)
                  );


  constructor (private fbService: FacebookService,
               private translateService: TranslateService) {
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lang = event.lang;
    });

    this.locales$
        .pipe(
          take(1)
        )
        .subscribe((locales: Array<Locale>) => this._locales = locales);
  }

}
